import { connect } from "react-redux";
import PlanChecklistV2 from "./Component";

const mapStateToProps = ({ planv2: { delays, planv2 } }) => ({
  planv2,
  delays,
});

export default connect(mapStateToProps)(PlanChecklistV2);
